import { useState, useEffect } from "react";

type TSort = {
    id: string;
    desc?: boolean;
}

const usePagination = () => {
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    });

    const [sorting, setSorting] = useState<TSort[]>([]);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const params = {
        pagination: {
            ...pagination,
            pageIndex: pagination.pageIndex + 1,
        },
        sorting: {
            sortBy: sorting.length ? sorting[0].id : undefined,
            isDescending: sorting.length ? sorting[0].desc : undefined,
        },
        filtering: {
            searchTerm: globalFilter,
        },
    };

    useEffect(() => {
        setPagination(prev => ({...prev, pageIndex: 0}));
    }, [sorting, globalFilter]);

    return {
        pagination,
        setPagination,

        sorting,
        setSorting,

        globalFilter,
        setGlobalFilter,

        params,

        getPageCount: meta => meta ? Math.ceil(meta.totalRecords / pagination.pageSize) : 1,
    };
};

export default usePagination;
